import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import Tooltip from "@material-ui/core/Tooltip";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import Input from "@material-ui/core/Input";

import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { getErrorString } from "../display/ErrorStrings";
import PopupMessage from "../components/PopupMessage";
import ViewPdf from "../components/ViewPdf";
import CdisbDetailDetails from "../details/CdisbDetailDetails";

import SearchIcon from "@material-ui/icons/PageviewOutlined";
import PDFViewIcon from "@material-ui/icons/PictureAsPdfOutlined";
import PrintIcon from "@material-ui/icons/PrintOutlined";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
});

class CdisbDetailPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      report: {},
      viewPdf: false,
      searchOk: false,
      viewPopup: false,
    };
    this.onClosePopup = this.onClosePopup.bind(this);
  }

  handleChange(e) {
    e.preventDefault();
    this.props.onReportChange(e);
  }

  handleSearch(e) {
    let myUrl = this.getUrl("on_cdisb_detail_request");
    this.search(myUrl);
  }

  handlePdf(e) {
    this.setState({ viewPdf: true });
  }

  handlePrint(e) {
    var prtContent = document.getElementById("myReport");
    var winPrint = window.open(
      "",
      "",
      "left=0,top=0,width=800,height=600,toolbar=0,scrollbars=0,status=0"
    );
    winPrint.document.write(prtContent.innerHTML);
    winPrint.document.close();
    winPrint.focus();
    winPrint.print();
    winPrint.close();
  }

  getUrl(requestType) {
    return requestType;
    /*let myUrl = this.getBaseUrl(requestType) +
	  '&r=' + new Date().getTime() +
	  '&token=' + this.props.secureToken;
	  return myUrl;*/
  }

  getBaseUrl(requestType) {
    /*let baseUrl = requestType + '?transit=' + 
		  this.props.accountObject.transit + 
		  '&account=' + this.props.accountObject.account;*/
    let baseUrl = requestType;
    return baseUrl;
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ viewPdf: false });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
  }

  search(myUrl) {
    fetch(myUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          this.setState({ report: reply });
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
            this.setState({ viewPopup: true });
          } else {
            this.setState({ searchOk: true });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  getSearchObject() {
    let data = {
      r: new Date().getTime(),
      secureToken: this.props.secureToken,
      transit: this.props.accountObject.transit,
      account: this.props.accountObject.account,
    };
    return data;
  }

  render() {
    let myPdfUrl = this.getBaseUrl("on_cdisb_detail_pdf_request");
    let options = this.props.reports;
    let { t } = this.props;
    return (
      <div>
        {this.state.viewPdf && (
          <ViewPdf
            history={this.props.history}
            secureToken={this.props.secureToken}
            postData={this.getSearchObject()}
            onClosePopup={this.onClosePopup}
            pdfUrl={myPdfUrl}
            report={this.state.report}
            nopagination="yes"
          />
        )}
        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewPopup && this.state.notifyString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.info.title", "Information")}
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClosePopup}
          />
        )}
        <div>
          <Paper elevation={5}>
            <FormGroup row>
              <div>
                <Typography variant="caption">
                  {t("report.label")}&nbsp;&nbsp;
                </Typography>
                <FormControl>
                  <NativeSelect
                    style={{ height: 48, verticalAlign: "textTop", margin: 0 }}
                    defaultValue={this.props.option.index}
                    input={<Input id="report_options" />}
                    onChange={(event) => this.handleChange(event)}
                  >
                    {options.map((n) => {
                      return <option value={n.index}>{n.description}</option>;
                    })}
                  </NativeSelect>
                </FormControl>
                &nbsp;&nbsp;
              </div>

              <Tooltip
                title={
                  t("showSearchResult.tip") + this.props.option.description
                }
              >
                <Button
                  color="primary"
                  onClick={(event) => this.handleSearch(event)}
                >
                  <SearchIcon />
                  &nbsp;{t("search.button")}
                </Button>
              </Tooltip>
              <Tooltip title={t("viewPdfReport.tip")}>
                <Button
                  color="primary"
                  onClick={(event) => this.handlePdf(event)}
                >
                  <PDFViewIcon />
                  &nbsp;{t("pdf.button")}
                </Button>
              </Tooltip>
              {this.state.searchOk && (
                <Tooltip title={t("printReport.tip")}>
                  <Button
                    color="primary"
                    onClick={(event) => this.handlePrint(event)}
                  >
                    <PrintIcon />
                    &nbsp;{t("printReport.tip")}
                  </Button>
                </Tooltip>
              )}
            </FormGroup>
          </Paper>
        </div>
        {this.state.searchOk && (
          <div id="myReport">
            <CdisbDetailDetails report={this.state.report} />
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(CdisbDetailPage));
